// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"6a9a69a3","136":"62cf8900","156":"1f478b3f","184":"1fb79bed"}[chunkId] + ".chunk.js";
};